(function () {

  function initCountdown(section) {

    const wrapper = section.querySelector('.countdown-wrapper');
    const countdown = section.querySelector('#countdown');

    if (!wrapper || !countdown) return;

    const startDate = countdown.dataset.startDate;
    const startTime = countdown.dataset.startTime;
    const endDate = countdown.dataset.endDate;
    const endTime = countdown.dataset.endTime;

    if (!startDate || !startTime || !endDate || !endTime) return;

    /* Same date logic */
    const start = new Date(startDate + 'T' + startTime + ':00');
    const end = new Date(endDate + 'T' + endTime + ':59');

    if (isNaN(start.getTime()) || isNaN(end.getTime())) return;

    const daysEl = wrapper.querySelector('#days');
    const hoursEl = wrapper.querySelector('#hours');
    const minutesEl = wrapper.querySelector('#minutes');
    const secondsEl = wrapper.querySelector('#seconds');
    const contentEl = wrapper.querySelector('#content');

    let interval;

    function getPacificNow() {
      return new Date(
        new Date().toLocaleString("en-US", { timeZone: "America/Los_Angeles" })
      ).getTime();
    }

    function updateCountdown() {

      /* USA Pacific Time */
      const now = getPacificNow();

      const distance = end.getTime() - now;

      /* hide before start */
      if (now < start.getTime()) {
        wrapper.style.display = 'none';
        return;
      }

      wrapper.style.display = 'flex';

      if (distance <= 0) {

        countdown.style.display = 'none';

        if (contentEl) {
          contentEl.style.display = 'block';
        }

        clearInterval(interval);
        return;
      }

      const day = 1000 * 60 * 60 * 24;
      const hour = 1000 * 60 * 60;
      const minute = 1000 * 60;

      if (daysEl) daysEl.innerText = Math.floor(distance / day);
      if (hoursEl) hoursEl.innerText = Math.floor((distance % day) / hour);
      if (minutesEl) minutesEl.innerText = Math.floor((distance % hour) / minute);
      if (secondsEl) secondsEl.innerText = Math.floor((distance % minute) / 1000);
    }

    updateCountdown();
    interval = setInterval(updateCountdown, 1000);
  }

  document.addEventListener('DOMContentLoaded', function () {

    const sections = document.querySelectorAll('.countdown-container');

    if (!sections.length) return;

    sections.forEach(function(section){
      initCountdown(section);
    });

  });

  document.addEventListener('shopify:section:load', function (event) {
    initCountdown(event.target);
  });

})();